import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const MobileStickyCTA = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pathname === "/contact") {
      setVisible(false);
      return;
    }
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    const target = document.querySelector('[data-testid="contact-form"], #inquiry');
    let observer;
    if (target) {
      observer = new IntersectionObserver(
        ([entry]) => setVisible(!entry.isIntersecting && window.scrollY > 400),
        { threshold: 0.15 }
      );
      observer.observe(target);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (observer) observer.disconnect();
    };
  }, [pathname]);

  if (pathname === "/contact") return null;

  return (
    <div
      data-testid="mobile-sticky-cta"
      aria-hidden={!visible}
      className={`fixed inset-x-0 bottom-0 z-30 border-t border-brand-navy/15 bg-white/98 px-4 py-3 backdrop-blur-lg transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <Link
        to="/contact"
        data-testid="mobile-sticky-cta-link"
        className="flex min-h-[48px] w-full items-center justify-center gap-2 rounded-lg bg-brand-cta px-6 py-3 text-sm font-semibold text-brand-navy shadow-[0_6px_20px_-4px_rgba(255,215,0,0.55)]"
      >
        Book a Consultation
        <ArrowUpRight className="h-4 w-4" />
      </Link>
    </div>
  );
};
